/*
* @About gongw created by 2021/2/23
*/
let baseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseUrl = 'http://192.168.130.48:8882'//本地
  // baseUrl = 'http://118.195.213.209:9989'//测试
   baseUrl = 'https://www.jingweicd.com/api'//线上*
  //baseUrl = 'http://192.168.0.65:8888'
} else {
  // baseUrl = 'http://192.168.130.48:8882'//本地
  // baseUrl = 'http://118.195.213.209:9989'//测试
   baseUrl = 'https://www.jingweicd.com/api'//线上
  //baseUrl = 'http://192.168.0.65:8888'
}
export default baseUrl
